import { request } from './axios.js'
export function addKiaCusApi(data) {
  return request({
    data,
    // url: '/kia/kiaCus/add',
    url: '/webapp/api/kiaCus/add',
  })
}